class OTFControlImageSelect {
    container = '[otf-select-image-control]';
    listImage = '.select-list-image';

    settingId  = '';
    $container = '';

    constructor() {
        this.createImageSelectLayout();

        $('body').on('click', (event) => {
            if($(event.currentTarget).hasClass('changing-image')){
                this.closePanel();
            }
        });

        $(`#customize-theme-controls ${this.container} ${this.listImage} li`).on('click', (event) => {
            let $li = $(event.currentTarget);
            if (!$li.hasClass('active')) {
                let $ul        = $li.closest(this.listImage);
                let $container = $li.closest(this.container);
                $ul.children('li').removeClass('active');
                $li.addClass('active');

                OTFCustomizeCore.setValue($container, $li.find('img').attr('alt'));
            }
        });

        $(document).on('click', '.button-change-image', (event) => {
            event.preventDefault();
            let $body = $('body');
            if ($body.hasClass('changing-image')) {
                this.closePanel();
            } else {
                this.$container = $(event.currentTarget).closest('.opal-control-image-select');
                let $listImage  = this.$container.children('.image-select');
                let contentHtml = $listImage.html();
                this.settingId  = this.$container.data('id');

                this.setPanelContent(contentHtml.trim());
                $body.addClass('changing-image');
            }

        }).on('click', '.image-select-tpl', (event) => {
            event.stopPropagation();
            let $item = $(event.currentTarget);
            if (!$item.hasClass('active') && this.$container) {
                let $container = $(`#customize-control-${this.settingId}`);
                let value      = $item.children('img').attr('alt');

                $container.find('.image-select-tpl').removeClass('active');
                $container.find(`.image-select-tpl[data-value="${value}"]`).addClass('active');
                OTFCustomizeCore.setValue(this.$container, value);
            }
            this.closePanel();
        })
    }

    createImageSelectLayout() {
        $('body .wp-full-overlay').append(`<div id="select-image-left"><!-- compatibility with JS which looks for widget templates here -->
    <div id="available-select-image">
        <div id="available-images-list">
                
        </div><!-- #available-images-list -->
    </div><!-- #available-select-image -->
</div>`);
    }

    setPanelContent(content) {
        $('#available-images-list').html(content);
    }

    closePanel() {
        $('body').removeClass('changing-image');
    }
}